import './user_profile_attribute_view.js.coffee'

class Customer.FreeTextUserProfileAttributeView extends Customer.UserProfileAttributeView
  template: JST["backbone/templates/customer/users/custom_attributes/free_text"]
  valueTemplate: JST["backbone/templates/customer/users/custom_attributes/values/free_text"]
  inputType: 'text'

  render: =>
    super
    @disabled = false
    _.each @model.get('value'), (value) =>
      @appendValue(value['value'])
    @$el.find('.add-new-value').on 'click', =>
      @addNewValue()
    @updateDisabled()
    @

  addNewValue: =>
    unless @disabled
      @appendValue('').find('.input').focus()
      @modifyAnything()
      @autoResizeInput()

  autoResizeInput: =>
    @$el.find('textarea.input').on 'input propertychange', @resizeInput

  resizeInput: (event) ->
    textarea = event.currentTarget || event
    paddingHeight = parseInt($(textarea).css("padding-top").replace(/px/,"")) + parseInt($(textarea).css("padding-bottom").replace(/px/,""))
    textarea.style.height = "" # reset the height
    textarea.style.height = "#{textarea.scrollHeight - paddingHeight}px"

  getAdded: ->
    @getValues
      additionalValueSelector: '.new-value:not(.deleted-value)'
      inputSelector: '.input'
      validationRequired: true

  getDeleted: ->
    @getValues
      additionalValueSelector: '.deleted-value:not(.new-value)'
      inputSelector: '.input'
      validationRequired: false

  getValues: ({additionalValueSelector, inputSelector, validationRequired}) =>
    values = []
    @$el.find(".value#{additionalValueSelector || ''}").each ->
      $input = $(this).find(inputSelector)
      if $input.isInputValid() or !validationRequired
        value = $input.val().trim()
        values.push value if String(value)

    definition_code: @model.get('definition').code,
    values: _.filter(values, (value) -> value != null)

  appendValue: (value) =>
    unless @disabled
      calculatedHeight = Math.max(value.length/13, 2)
      $value = $(@valueTemplate(value: value, type: @inputType, height: "#{calculatedHeight}vh"))

      $value.find('.input').on('change keyup', @modifyAnything)
      $value.find('.input').on('change cut', @modifyAnything)
      $value.find('.input').on('change paste', @modifyAnything)

      @$el.find('.values').append($value)
      $value.find('.delete-value > img').on('click', @deleteValue)
      $value

  deleteValue: (event) =>
    unless @disabled
      $(event.target).parent().parent().addClass('deleted-value')
      @modifyAnything()

  modifyAnything: (event) =>
    @trigger 'profile_custom_attributes:modified_field'
    @updateDisabled()

  updateDisabled: =>
    $notLast = @$el.find('.value.new-value:not(.deleted-value):not(:last)').find('.input')
    $last = @$el.find('.value.new-value:not(.deleted-value):last').find('.input')

    $notLast.prop('readonly', true)
    $last.prop('readonly', false)

    thereAreNoValues = @$el.find('.value:not(.deleted-value)').length == 0
    canAddMultiple = @model.get('definition').multiple
    lastValueIsValid = ($last.length == 0) or ($last.length != 0 and $last.val().trim() != '' and $last.isInputValid())

    canAddNewValue = lastValueIsValid and canAddMultiple
    canAddNewValue ||= thereAreNoValues

    if canAddNewValue then @$el.find('.add-new-value').removeClass('disabled') else @$el.find('.add-new-value').addClass('disabled')
    @$el.find('.add-new-value').prop('disabled', not canAddNewValue)

  afterRender: ->
    _.each(@$el.find('.input'), (textarea) =>
      @resizeInput(textarea)
    )

  disableFurtherChange: ->
    @$el.find('.input').prop("readonly",true)
    @$el.find('.delete-value').addClass('disabled')
    @$el.find('.add-new-value').addClass('disabled')
    @disabled = true
